export const validateAscii = (input, maxLength = 0) => RegExp("^[ -~]" + (!maxLength ? "+" : "{0," + maxLength + "}") + "$").test(input);
export const NOTES_MAX_LENGTH = 300;